<template>
  <div>
    <livechat-search v-model="showSearch"></livechat-search>
    <div id="livechat">
      <v-layout fill-height>
        <v-flex shrink fill-height style="width: 82px">
          <template v-if="$store.state.livechat.pageid">
            <livechat-pagelist
              :value="$store.state.livechat.pageid"
              @changePage="changePage"
            ></livechat-pagelist>
          </template>
        </v-flex>
        <v-flex fill-height style="position: relative; width: calc(100% - 82px)">
          <v-layout>
            <v-flex style="border-right: 1px solid #eee; max-width: 20%; min-width: 265px">
              <div id="chattype">
                <template v-if="searchlist.length == 0">
                  <livechat-tab
                    :newchatnotify="newchatnotify"
                    @refresh="handleReloadUser"
                    @onsearch="showSearch = true"
                  ></livechat-tab>
                </template>
                <template v-else>
                  <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
                  <v-divider></v-divider>
                </template>
              </div>

              <div v-if="$store.state.livechat.app">
                <users
                  v-if="$store.state.livechat.type == 'admin'"
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'admin'"
                  @onChangeFilter="handleChangeFilter"
                ></users>
                <users
                  v-if="$store.state.livechat.type == 'bot'"
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'bot'"
                  @onChangeFilter="handleChangeFilter"
                ></users>
              </div>
            </v-flex>
            <v-flex style="max-width: 80%">
              <v-layout>
                <v-flex
                  v-if="selectedUser"
                  :key="`chat_${selectedUser.userid}_${selectedUser.type}`"
                  style="
                    border-right: 1px solid #eee;
                    position: relative;
                    max-width: calc(100% - 335px);
                  "
                  fill-height
                >
                  <chatbox
                    :key="selectedUser.userid"
                    :newchatnotify="newchatnotify"
                    @endSession="onEndSession"
                    @openSession="onOpenSession"
                  ></chatbox>
                </v-flex>
                <v-flex
                  v-if="selectedUser"
                  style="position: relative; width: 310px; max-width: 310px"
                  fill-height
                >
                  <livechat-chattool :selected-user="selectedUser"></livechat-chattool>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <audio
      v-show="false"
      id="noti_sound"
      src="https://enterprise-s3.zwiz.app/sound/noti_sound.m4a"
      type="audio/x-m4a"
      preload="auto"
      controls
    ></audio>
  </div>
</template>

<script>
import Livechat from './Livechat.js'
export default {
  name: 'LivechatView',
  mixins: [Livechat]
}
</script>

<style></style>
<style>
.newnotifycount {
  line-height: 16px;
  border-radius: 15px;
  position: absolute;
  right: 3px;
  top: 5px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #ff6565;

  font-size: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue